
      import { requestAnimationFrame } from '@folkjs/dom/rAF';
      import * as V from '@folkjs/geometry/Vector2';
      import '@folkjs/labs/standalone/folk-shape';
      import '@folkjs/labs/standalone/folk-event-propagator';
      import { Gizmos } from '@folkjs/canvas/folk-gizmos';

      const ropes = Array.from(document.querySelectorAll('folk-event-propagator'));
      let orientationEvent;

      const gravitySlider = document.getElementById('gravityScale');
      const gravityScaleValue = document.getElementById('gravityScaleValue');

      // Initialize gravity scale from slider's initial value
      gravityScale = parseInt(gravitySlider.value);
      gravityScaleValue.textContent = gravityScale;

      gravitySlider.addEventListener('input', (e) => {
        gravityScaleValue.textContent = gravitySlider.value;
      });

      function tick() {
        requestAnimationFrame(tick);

        if (orientationEvent === undefined) return;

        window.alpha.textContent = Math.round(orientationEvent.alpha);
        window.beta.textContent = Math.round(orientationEvent.beta);
        window.gamma.textContent = Math.round(orientationEvent.gamma);

        // Convert angles to radians
        const beta = orientationEvent.beta * (Math.PI / 180); // Pitch (x-axis)
        const gamma = orientationEvent.gamma * (Math.PI / 180); // Roll (y-axis)

        // Calculate the downward vector on the screen plane
        const downwardVector = { x: Math.sin(gamma), y: Math.sin(beta) };

        // Compute magnitude and normalized direction
        const magnitude = V.magnitude(downwardVector);
        const direction = V.normalized(downwardVector);

        // Scale the vector by gravity constant
        const gravity = V.scale(direction, magnitude * gravitySlider.valueAsNumber);

        window.gravity.textContent = `${Math.round(gravity.x)}, ${Math.round(gravity.y)}`;

        // Draw the gravity vector
        const center = {
          x: window.innerWidth / 2,
          y: window.innerHeight / 2,
        };

        Gizmos.clear();
        Gizmos.vector(
          center,
          {
            x: gravity.x / 10,
            y: gravity.y / 10,
          },
          { color: 'grey', width: 3, size: 15 },
        );

        ropes.forEach((rope) => {
          rope.gravity = gravity;
        });
      }

      tick();

      function onDeviceOrientation(e) {
        orientationEvent = e;
      }

      window.enableGravity = async function enableGravity() {
        if (DeviceOrientationEvent.requestPermission) {
          const permission = await DeviceOrientationEvent.requestPermission();

          if (permission === 'granted') {
            console.info('Permission granted');
          } else {
            console.warn('Permission for device orientation rejected', permission);
          }
        }

        window.addEventListener('deviceorientation', onDeviceOrientation);
      };
    